import Image from 'next/image';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { Text } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import {
  paymentResponseByBotTriageLead,
  RELOAD_AFTER_DURATION_IN_SEC
} from '@/services/payment.service';

const SkeletonLoader = () => (
  <div className='mt-14 px-10 mx-auto absolute top-0 right-0 left-0'>
    <div className='w-full md:w-100 mx-auto'>
      <div className='w-64 mx-auto'>
        <Skeleton {...{ height: 30, width: 253 }} />
      </div>
      <div className='w-28 mx-auto my-8 md:my-12'>
        <Skeleton {...{ height: 112, width: 112 }} />
      </div>
      <div className='flex flex-col gap-2'>
        <Skeleton {...{ height: 26 }} />
        <Skeleton {...{ height: 52 }} />
      </div>
      <div className='flex flex-col gap-3 mt-8'>
        <Skeleton {...{ height: 52 }} />
        <Skeleton {...{ height: 52 }} />
      </div>
      <div className='mt-2'>
        <Skeleton {...{ height: 26 }} />
      </div>
    </div>
  </div>
);

const AcknowledgementDetails = ({
  botTriageLeadNumber,
  botTriageLeadPaymentId,
  countdown
}) => (
  <div className='mt-40 relative z-99 md:w-150 mx-auto px-5 md:px-0 text-white text-center'>
    <Text
      {...{
        className: 'text-xl md:text-3xl font-medium',
        content: 'Request Acknowledged!'
      }}
    />
    <Text
      {...{
        className: 'text-xl md:text-3xl font-medium',
        content: 'Your payment is still in-process'
      }}
    />
    <div className='mb-15 text-center'>
      <Image
        alt='loading'
        className='mx-auto'
        height={80}
        width={95}
        src={`${staticMediaStoreBaseURL}/icons/loading.gif`}
        style={{
          width: '95px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
    </div>
    <div className='text-lightgray text-base font-light'>
      <Text
        {...{
          content: `Reference number: ${botTriageLeadNumber}`,
          HtmlTag: 'span'
        }}
      />
    </div>
    <div className='text-lightgray text-base font-light'>
      <Text
        {...{
          content: `BTL Payment Id: ${botTriageLeadPaymentId}`,
          HtmlTag: 'span'
        }}
      />
    </div>
    <div className='pt-6'>
      <Text
        {...{
          className: 'text-lightgray text-base font-light',
          content:
            'Please do not refresh the page or hit back button, the page will automatically refresh the status in',
          HtmlTag: 'span'
        }}
      />
      <Text
        {...{
          className: 'text-brand text-base font-light',
          content: ` ${countdown} seconds`,
          HtmlTag: 'span'
        }}
      />
    </div>
  </div>
);

const BotTriageLeadPaymentAcknowledgement = ({
  botTriageLeadId,
  botTriageLeadNumber,
  botTriageLeadPaymentId,
  countdown,
  setCountdown,
  setPaymentReceiptStatus,
  setShowToast
}) => {
  useEffect(() => {
    if (countdown > 0) {
      setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else {
      paymentResponseByBotTriageLead({
        paymentStatusAPIInput: { botTriageLeadId, botTriageLeadPaymentId },
        resetCountDownTo: RELOAD_AFTER_DURATION_IN_SEC,
        setCountdown,
        setPaymentReceiptStatus,
        setShowToast
      });
    }
  }, [countdown]);

  return (
    <div className='overflow-hidden'>
      <div className='bg-nero fixed top-0 w-full min-h-screen z-50 opacity-80'></div>
      <AcknowledgementDetails
        {...{ botTriageLeadNumber, botTriageLeadPaymentId, countdown }}
      />
      <SkeletonLoader />
    </div>
  );
};

export default BotTriageLeadPaymentAcknowledgement;
